import { Plugin } from 'vue';
import { kebabCase } from 'lodash';
import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const useComponentsStore = defineStore('cms-components', () =>
{
    const modules = reactive<string[]>([]);
    const widgets = reactive<string[]>([]);

    return { modules, widgets };
});
export interface ValidatableComponent
{
    validate(): Promise<void>
}

const ShopPlugin: Plugin =
{
    async install(app, options)
    {
        const store = useComponentsStore();

        // Widget settings
        const requireWidgetComponent = import.meta.glob('@/modules/shop/common/widgets/**/*Settings.vue', { eager: true });

        Object.values(requireWidgetComponent).forEach((component: any) =>
        {
            store.widgets.push(kebabCase(component.default.name));
            app.component(component.default.name, component.default);
        });
    }
};

export default ShopPlugin;
